export const CLIENT_FILTER_KEY = "client_filters";
export const CLIENT_SCROLL_KEY = "client_scroll_pos";
export const CLIENT_REFETCH_KEY = "client_refetch";

export enum VatType {
  VAT_REGISTERED = "vat_registered",
  NOT_VAT_REGISTERED = "not_vat_registered",
}

export const getVatTypeOptions = () => [
  { label: "VAT Registered", value: VatType.VAT_REGISTERED },
  { label: "Not VAT Registered", value: VatType.NOT_VAT_REGISTERED },
];

export const getVatPercentageOptions = () => [
  { label: "0% Zero Rate", value: 0 },
  { label: "13.5% Reduced Rate", value: 13.5 },
  { label: "20% Standard Rate (UK)", value: 20 },
  { label: "23% Standard Rate (Ireland)", value: 23 }
];

export const getValidVatPercentage = (val: any) => {
  if (val === null || val === undefined || val === "") return null;
  const numVal = Number(val);
  return isNaN(numVal) ? null : numVal;
};

export const getVatValue = (type: VatType) => {
  return (
    getVatTypeOptions().find((option) => option.value === type)?.label ||
    getVatTypeOptions()[1].label
  );
};
